import { render } from "./App.vue?vue&type=template&id=9c707318"
import script from "./Component-App.js?vue&type=script&lang=js&external"
export * from "./Component-App.js?vue&type=script&lang=js&external"

import "./App.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__